
import React from 'react'
import PropTypes from 'prop-types';
import Stepper from '@material-ui/core/Stepper';
import { Step, StepButton } from '@material-ui/core';
import theme from '../../../../assests/theme'
import { MuiGrid, MuiTypography, MuiToolTip, MuiHomeIcon } from '../../../ui/MaterialUIComponents';
import routes from "../../../navigation/Routes";
import { Link } from "react-router-dom";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import StepLabel from '@material-ui/core/StepLabel';
import { Redirect } from 'react-router-dom'
import spinner from "../../../ui/icons/spinner.gif";
import StepConnector from '@material-ui/core/StepConnector';
import { getKeyFromLS, setDataInLS } from '../../../../utils/LocalStorageUtil';
import { StepperUtil } from '.'

const StepCustomizedConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 17px)',
    right: 'calc(50% + 17px)',
  },
  active: {
    '& $line': {
      borderColor: theme.palette.orange,
    },
  },
  completed: {
    '& $line': {
      borderColor: theme.palette.orange,
    },
  },
  line: {
    borderColor: theme.palette.orange,
    borderTopWidth: 1,
    borderRadius: 1,
  },
})(StepConnector);

const useStepIconStyles = makeStyles({
  root: {
    color: theme.palette.orange,
    display: 'flex',
    height: 22,
    alignItems: 'center',
    font: "Bold 9px/10px Arial"
  },
  active: {
    color: theme.palette.orange,

  },
  bigCircle: {
    width: "17px",
    height: "17px",
    borderRadius: '50%',
    backgroundColor: '#F9DBB8',

  },
  circle1: {
    width: "9px",
    height: "9px",
    borderRadius: '50%',
    backgroundColor: 'currentColor',
    position: "relative",
    top: "4px",
    margin: "0px 0px 0px 4px"
  },
  circle: {
    width: "9px",
    height: "9px",
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },

});
function StepIcon(props) {
  const classes = useStepIconStyles();
  const { active } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}

    >
      {active ?
        <div className={classes.bigCircle}>
          <div className={classes.circle1} />
        </div> :
        <div className={classes.circle} />
      }
    </div>
  );
}
StepIcon.propTypes = {
  active: PropTypes.bool,
};


const useStyles = () => ({
  root: {
    width: '90%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  completed: {
    display: 'inline-block',
  },
  instructions: {
    marginTop: theme.spacing(1),
    display: 'inline-block',
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
});

export function StepperComponent(props) {

  function getStepContent(step) {

    let StepComponent = step.container
    return (<MuiGrid container xs={props.displayError ? 10 : 12} ><StepComponent {...props} handleComplete={handleComplete} previousStep={previousStep} /></MuiGrid>)
  }

  const classes = useStyles();

  const steps = props.stepperJsonArray

  function setStepperLocalStorage(stepId) {
    let stepperState = getKeyFromLS(StepperUtil.STEPPER_STATE_KEY_LS) || {};
    stepperState.stepperIndex = stepId;
    setDataInLS(StepperUtil.STEPPER_STATE_KEY_LS, stepperState);
  }

  /* let stepperState = getKeyFromLS(StepperUtil.STEPPER_STATE_KEY_LS);
  let lStepperIndex = stepperState && stepperState.stepperIndex; */
  let lStepperIndex = props.stepperIndex;
  if (!lStepperIndex) {
    let stepperState = getKeyFromLS(StepperUtil.STEPPER_STATE_KEY_LS);
    let lStepperIndex = stepperState && stepperState.stepperIndex;
    //lStepperIndex = props.stepperIndex;



  } else {
    setStepperLocalStorage(lStepperIndex);
  }
  const [activeStepNumber, setActiveStepNumber] = React.useState(lStepperIndex);

  const [completed, setCompleted] = React.useState(new Set());
  const [skipped, setSkipped] = React.useState(new Set());
  React.useEffect(() => {
    if (props.isCreateNewSchool && props.location.pathname == '/addSchool') {

      if (activeStepNumber !== 0) {
        setActiveStepNumber(0)
        setStepperLocalStorage(0);

      }
      else {
        // Changes to be done
      }
    }
  });
  function totalSteps() {
    return steps.length
  }

  function isStepOptional(step) {
    return step === 1;
  }

  function skippedSteps() {
    return skipped.size;
  }

  function completedSteps() {
    return completed.size;
  }

  function allStepsCompleted() {
    return completedSteps() === totalSteps() - skippedSteps();
  }

  function isLastStep() {
    return activeStepNumber === totalSteps() - 1;
  }

  function handleNext() {
    const newActiveStepNumber = isLastStep() && !allStepsCompleted()
      ? // It's the last step, but not all steps have been completed
      // find the first step that has been completed
      steps.findIndex((step) => !completed.has(step))
      : activeStepNumber + 1;

    setActiveStepNumber(newActiveStepNumber);
    setStepperLocalStorage(newActiveStepNumber);

  }


  const handleStep = step => () => {
    setActiveStepNumber(step.id);
    setStepperLocalStorage(step.id);

  };

  function handleComplete() {
    const newCompleted = new Set(completed);
    newCompleted.add(steps[activeStepNumber]);
    setCompleted(newCompleted);

    /**
     * Sigh... it would be much nicer to replace the following if conditional with
     * `if (!this.allStepsComplete())` however state is not set when we do this,
     * thus we have to resort to not being very DRY.
     */

    if (completed.size !== (totalSteps() - skippedSteps())) {

      handleNext();
    }
  }

  function previousStep(isActive) {

    const newCompleted = new Set(completed);
    newCompleted.add(steps[activeStepNumber - 1]);
    setActiveStepNumber(0);
    setStepperLocalStorage(0);


    if (isActive === false) {
      setActiveStepNumber(1);
      setStepperLocalStorage(1);


    }
    if (isActive === true) {
      setActiveStepNumber(2);
      setStepperLocalStorage(2);
    }
  }
  function isStepSkipped(step) {
    return skipped.has(step);
  }

  const { i18n } = props
  return (
    <MuiGrid container xs={12} style={{ marginTop: '50px', padding: 16 }}>
      <form>
        <MuiGrid container xs={12} style={{ width: '95vw' }}>
          <MuiGrid container xs={12} justify='flex-start' alignItems='center' style={{ height: '100%' }}>
            <MuiGrid item >
              <Link
                style={{ textDecoration: 'none' }}
                to={{
                  pathname: (props.activeSchool !== undefined && props.activeSchool.createdBy != undefined ? routes.main : props.routeName),
                }}
              >{props.title !== undefined && props.title.length <= 15 ?
                <MuiGrid container justify='center' alignItems='center' >
                  <MuiGrid> <MuiHomeIcon color='primary'/></MuiGrid>
                  <MuiGrid>
                    <MuiTypography variant={theme.typographyStyles.H5} style={theme.gridHeaderTextStyle} >
                      &nbsp;&nbsp;{props.title != undefined ? props.title : i18n.schoolStepper.schoolProfile}
                    </MuiTypography></MuiGrid>
                </MuiGrid>

                :
                <MuiToolTip title={props.title} arrow placement="right">
                  <MuiGrid container justify='center' alignItems='center' >
                      <MuiGrid><MuiHomeIcon color='primary'/></MuiGrid>
                    <MuiGrid><MuiTypography variant={theme.typographyStyles.H5} style={theme.gridHeaderTextStyle} >
                      &nbsp;&nbsp;{props.title != undefined ? props.title.slice(0, 15) : i18n.schoolStepper.schoolProfile}
                    </MuiTypography></MuiGrid>
                  </MuiGrid>

                </MuiToolTip>}

              </Link>
            </MuiGrid>
            <MuiGrid item xs={12} sm={8} md={9}>
              <Stepper nonLinear activeStep={activeStepNumber} connector={<StepCustomizedConnector />}>
                {

                  steps.map((step, index) => {
                    const stepProps = {};
                    const buttonProps = {};
                    if (isStepOptional(step)) {
                      buttonProps.optional = <MuiTypography variant="caption"></MuiTypography>;
                    }
                    if (isStepSkipped(step)) {
                      stepProps.completed = false;
                    }
                    return (
                      <Step key={step.id} {...stepProps} >

                        <StepLabel StepIconComponent={StepIcon} onClick={handleStep(step)} style={{ cursor: 'pointer' }}>
                          {step.displayName}
                        </StepLabel>
                      </Step>
                    );
                  })}
              </Stepper>
            </MuiGrid></MuiGrid>
          {!props.verifyTimeTableInProgress && !props.generateTimeTableInProgress ?
            <MuiGrid container xs={12}  >
              {/* <MuiGrid item xs={12}>
                <MuiTypography className={classes.instructions}>

                </MuiTypography>
              </MuiGrid> */}


              <MuiGrid container xs={12}>{getStepContent(steps[activeStepNumber])}</MuiGrid>

              {/* <MuiGrid item xs={12}>
                  <MuiTypography variant="caption" className={classes.completed}>
                  </MuiTypography>
                </MuiGrid> */}

            </MuiGrid> :
            <MuiGrid container xs={12} style={{ marginTop: '75px' }}

              justify='center' alignItems='center'
            >
              <img src={spinner} alt="none" style={theme.spinnerImgStyle} />

            </MuiGrid>}

        </MuiGrid>
      </form>
    </MuiGrid>
  );
}
export default StepperComponent
